import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import EducationLibraryOptions from "./EducationLibraryOptions";
import VideoPlayer from "../common/videoPlayer";
import "./styles.css";

export default class Service1255 extends Component {
  handleVideoFinished = (id) => {
    this.setState({
      cardiologyButtons: this.state.cardiologyButtons.map((button) => {
        if (button.id === id) {
          return Object.assign({}, button, {
            checked: true,
          });
        } else {
          return button;
        }
      }),
    });
  };

  /**************
   * Properties *
   **************/

  /**
   * The service's different screens
   */
  bannerVisible = {
    visible: true,
  };
  categoryHeader = {
    id: "header",
    src: require("./images/1255_elements.png"),
  };
  categoryNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/main_menu",
  };
  categorySelect = require("./images/1255_btn_SelectCat.png");
  videoSelect = require("./images/1255_btn_WatchVid.png");
  categoryButtons = [
    {
      id: "cardiology",
      to: "cardiology",
      highlight: require("./images/Category1_HL.png"),
      unhighlight: require("./images/Category1_UH.png"),
      alt: "Cardiology",
    },
    {
      id: "explainingMedications",
      highlight: require("./images/Category2_HL.png"),
      unhighlight: require("./images/Category2_UH.png"),
      alt: "Explaining Medications",
    },
    {
      id: "infectionPrevention",
      highlight: require("./images/Category3_HL.png"),
      unhighlight: require("./images/Category3_UH.png"),
      alt: "Infection Prevention",
    },
    {
      id: "jointReplacement",
      highlight: require("./images/Category4_HL.png"),
      unhighlight: require("./images/Category4_UH.png"),
      alt: "Joint Replacement",
    },
    {
      id: "motherBaby",
      highlight: require("./images/Category5_HL.png"),
      unhighlight: require("./images/Category5_UH.png"),
      alt: "Mother/Baby",
    },
    {
      id: "painControl",
      highlight: require("./images/Category6_HL.png"),
      unhighlight: require("./images/Category6_UH.png"),
      alt: "Pain Control",
    },
    {
      id: "patientSafety",
      highlight: require("./images/Category7_HL.png"),
      unhighlight: require("./images/Category7_UH.png"),
      alt: "Patient Safety",
    },
  ];
  categoryButtonList = {
    top: 170,
    left: 135,
  };
  cardiologyHeader = Object.assign({}, this.categoryHeader);
  cardiologyText = {
    id: "text",
    src: require("./images/hdr_Cardiology.png"),
    top: 150,
    left: 0,
  };
  cardiologyButtonList = {
    top: 250,
    left: 135,
  };
  cardiologyNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/education_library",
  };
  videoNavigationBar = {
    mainMenu: false,
    back: false,
    backRoute: null,
    doGoBack: true,
  };
  defaultVideo = {
    id: "default",
    src: require("./videos/Heart_Attack_Signs_Symptoms_226016HD.mp4"),
    onVideoEnded: this.handleVideoFinished,
  };
  signsAndSymptomsHeartAttack = Object.assign({}, this.defaultVideo, {
    id: "signsAndSymptomsHeartAttack",
  });
  understandingCoronaryArteryDisease = Object.assign({}, this.defaultVideo, {
    id: "understandingCoronaryArteryDisease",
    src: require("./videos/Coronary_Artery_Disease_226002HD.mp4"),
  });
  symptomsHeartAttackCommonWomen = Object.assign({}, this.defaultVideo, {
    id: "symptomsHeartAttackCommonWomen",
  });
  understandingAtrialFibrilation = Object.assign({}, this.defaultVideo, {
    id: "understandingAtrialFibrilation",
    src: require("./videos/Coronary_Artery_Disease_226002HD.mp4"),
  });
  whatIsHeartFailure = Object.assign({}, this.defaultVideo, {
    id: "whatIsHeartFailure",
  });
  heartSurgeryMovingAlongYourRecoveryPath = Object.assign(
    {},
    this.defaultVideo,
    {
      id: "heartSurgeryMovingAlongYourRecoveryPath",
      src: require("./videos/Coronary_Artery_Disease_226002HD.mp4"),
    }
  );
  state = {
    cardiologyButtons: [
      {
        id: "signsAndSymptomsHeartAttack",
        to: "signs_and_symptoms_heart_attack",
        highlight: require("./images/Cat1_Title1_HL.png"),
        unhighlight: require("./images/Cat1_Title1_UH.png"),
        alt: "signsAndSymptomsHeartAttack",
        checked: false,
      },
      {
        id: "understandingCoronaryArteryDisease",
        to: "understanding_coronary_artery_disease",
        highlight: require("./images/Cat1_Title3_HL.png"),
        unhighlight: require("./images/Cat1_Title3_UH.png"),
        alt: "understandingCoronaryArteryDisease",
        checked: false,
      },
      {
        id: "symptomsHeartAttackCommonWomen",
        to: "symptoms_heart_attack_common_women",
        highlight: require("./images/Cat1_Title2_HL.png"),
        unhighlight: require("./images/Cat1_Title2_UH.png"),
        alt: "symptomsHeartAttackCommonWomen",
        checked: false,
      },
      {
        id: "understandingAtrialFibrilation",
        to: "understanding_atrial_fibrilation",
        highlight: require("./images/Cat1_Title4_HL.png"),
        unhighlight: require("./images/Cat1_Title4_UH.png"),
        alt: "understandingAtrialFibrilation",
        checked: false,
      },
      {
        id: "whatIsHeartFailure",
        to: "what_is_heart_failure",
        highlight: require("./images/Cat1_Title5_HL.png"),
        unhighlight: require("./images/Cat1_Title5_UH.png"),
        alt: "whatIsHeartFailure",
        checked: false,
      },
      {
        id: "heartSurgeryMovingAlongYourRecoveryPath",
        to: "heart_surgery_moving_along_your_recovery_path",
        highlight: require("./images/Cat1_Title6_HL.png"),
        unhighlight: require("./images/Cat1_Title6_UH.png"),
        alt: "heartSurgeryMovingAlongYourRecoveryPath",
        checked: false,
      },
    ],
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1255">
        <Switch>
          <Route
            path="/education_library/categories"
            render={(routeProps) => (
              <EducationLibraryOptions
                {...routeProps}
                header={this.categoryHeader}
                banner={this.bannerVisible}
                navigationBar={this.categoryNavigationBar}
                imageButtonsList={this.categoryButtonList}
                imageButtons={this.categoryButtons}
                selectButton={this.categorySelect}
              />
            )}
          />
          <Route
            path="/education_library/cardiology"
            render={(routeProps) => (
              <EducationLibraryOptions
                {...routeProps}
                header={this.cardiologyHeader}
                text={this.cardiologyText}
                banner={this.bannerVisible}
                navigationBar={this.cardiologyNavigationBar}
                imageButtonsList={this.cardiologyButtonList}
                imageButtons={this.state.cardiologyButtons}
                selectButton={this.videoSelect}
              />
            )}
          />
          <Route
            path="/education_library/signs_and_symptoms_heart_attack"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.signsAndSymptomsHeartAttack}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/education_library/symptoms_heart_Attack_common_women"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.symptomsHeartAttackCommonWomen}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/education_library/understanding_coronary_artery_disease"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.understandingCoronaryArteryDisease}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/education_library/understanding_atrial_fibrilation"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.understandingAtrialFibrilation}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/education_library/what_is_heart_failure"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.whatIsHeartFailure}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/education_library/heart_surgery_moving_along_your_recovery_path"
            render={(routeProps) => (
              <VideoPlayer
                {...routeProps}
                {...this.heartSurgeryMovingAlongYourRecoveryPath}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/education_library"
            render={() => <Redirect to="/education_library/categories" />}
          />
        </Switch>
      </div>
    );
  }
}
